var map = {
	"./avatar/avatar-1.png": 2511,
	"./avatar/avatar-2.png": 7882,
	"./avatar/avatar-3.png": 7787,
	"./avatar/avatar-4.png": 9128,
	"./avatar/me.png": 6261,
	"./avatar/me2.png": 933,
	"./avatar/my-avatar.png": 4804,
	"./clients/btn-properti.png": 5511,
	"./clients/cimb.png": 1824,
	"./clients/ist.png": 7761,
	"./clients/nocola.png": 345,
	"./clients/permata.png": 564,
	"./projects/atm-cimb.png": 8334,
	"./projects/box-parking-guide.jpg": 9704,
	"./projects/btn-properti.jpg": 275,
	"./projects/digipos-aja.jpg": 1170,
	"./projects/module-smarthome.png": 3238,
	"./projects/parking-guide.png": 9127,
	"./projects/permata.jpg": 8558,
	"./projects/tanyo.png": 5730,
	"./projects/timer-softgun.png": 8104,
	"./projects/usahaku.jpg": 3734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;